module.exports = __webpack_public_path__ + "d72bffe4b1000023c3d32044ed0a4230.png";